module.exports = __webpack_public_path__ + "static/media/desktop.229b5cda.svg";